import { useCallback, useEffect } from 'react';
import { useFetcher } from 'react-router';

import { useActualBagSize } from '@jane/bloom/hooks/useBagSize';
import { CartAction } from '@jane/bloom/types/actions/cart';

export const useRefreshCart = () => {
  const fetcher = useFetcher();
  const bagSize = useActualBagSize();

  const fetchLatestCart = useCallback(() => {
    if (bagSize > 0) {
      fetcher.submit(
        {
          intent: CartAction.RefreshCart,
        },
        { action: `/checkout`, method: 'post' }
      );
    }
  }, [bagSize, fetcher]);

  useEffect(() => {
    document.addEventListener('visibilitychange', fetchLatestCart);
    window.addEventListener('focus', fetchLatestCart);

    return () => {
      document.removeEventListener('visibilitychange', fetchLatestCart);
      window.removeEventListener('focus', fetchLatestCart);
    };
  }, [fetchLatestCart]);
};
